import { useDispatch } from 'react-redux'
import { MapDescriptionDrawer as Drawer, useIsMobile } from 'ui-components'
import { useIsMapSaved } from '~map-preview/states/map'
import {
  closeMapDescriptionDrawer,
  openMapDescriptionDrawer,
  useIsMapDescriptionDrawerOpen
} from '~map-preview/states/ui'

import { useEffect } from 'react'
import { useIsEmbed } from '~map-preview/hooks/useIsEmbed'
import { MapDataSettingsButton } from './MapDataSettingsButton'
import { MapDescriptionEditor } from './MapDescriptionEditor'
import { MapDescriptionTags } from './MapDescriptionTags'
import { MapDescriptionTitle } from './MapDescriptionTitle'
import { MapDescriptionWorkspaceLink } from './MapDescriptionWorkspaceLink'
import { MapRemixButton } from './MapRemixButton'
import { MapStarButton } from './MapStarButton'

function MapDescriptionDrawer() {
  const isEmbed = useIsEmbed()
  const dispatch = useDispatch()
  const open = useIsMapDescriptionDrawerOpen()
  const isMobile = useIsMobile()
  const saved = useIsMapSaved()

  const handleClose = () => {
    dispatch(closeMapDescriptionDrawer())
  }

  // automatically open the drawer on desktop
  useEffect(() => {
    if (!isMobile && !open && saved) {
      dispatch(openMapDescriptionDrawer())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobile, saved])

  return (
    <Drawer
      isEmbed={isEmbed}
      open={open}
      onClose={handleClose}
      slots={{
        MapDescriptionTitle,
        MapDescriptionWorkspaceLink,
        MapDescriptionTags,
        MapDescriptionEditor,
        MapDataSettingsButton,
        MapRemixButton,
        MapStarButton
      }}
    />
  )
}

export { MapDescriptionDrawer }
